/*global REACT_APP_API_BASE_URL_NEW:true*/
import request from "@/utils/request";

export async function updateDocument(file, purpose, identifier) {
  const formData = new FormData();
  formData.append("file", file);

  const params = {
    mediaPurpose: purpose,
  };

  if (identifier) {
    params.identifier = identifier;
  }

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/media-service/media/upload`, {
    method: "POST",
    params,
    data: formData,
  });

  return result.data;
}

export async function getSignedUrl(fileName) {
  const params = {
    fileName,
  };

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/media-service/media/signed-uri`, {
    method: "GET",
    params,
  });

  if (result?.error) {
    throw new Error(result?.error);
  }

  return result.data;
}

export async function downloadDocument(fileName) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/media-service/media/download`, {
    method: "GET",
    params: {
      fileName,
    },
  });

  if (result?.error) {
    throw new Error(result?.error);
  }

  return result?.data;
}
